import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export default function AccountChooserModal({ isOpen, contacts = [], onCancel, onConfirm }) {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as='div' className='relative z-50' onClose={onCancel}>
                <Transition.Child
                    as={Fragment}
                    enter='ease-out duration-150'
                    enterFrom='opacity-0'
                    enterTo='opacity-100'
                    leave='ease-in duration-100'
                    leaveFrom='opacity-100'
                    leaveTo='opacity-0'
                >
                    <div className='fixed inset-0 bg-black/40' />
                </Transition.Child>

                <div className='overflow-y-auto fixed inset-0'>
                    <div className='flex justify-center items-center p-4 min-h-full'>
                        <Transition.Child
                            as={Fragment}
                            enter='ease-out duration-150'
                            enterFrom='opacity-0 scale-95'
                            enterTo='opacity-100 scale-100'
                            leave='ease-in duration-100'
                            leaveFrom='opacity-100 scale-100'
                            leaveTo='opacity-0 scale-95'
                        >
                            <Dialog.Panel className='overflow-hidden p-6 w-full max-w-lg text-left align-middle bg-white rounded-2xl shadow-xl transform'>
                                <Dialog.Title className='text-lg font-semibold'>Choose an account</Dialog.Title>
                                <p className='mt-1 text-sm text-gray-600'>
                                    We found multiple contacts for <strong>this email</strong>. Pick which account to
                                    continue with.
                                </p>

                                <div className='mt-4 space-y-2'>
                                    {contacts.map((c) => (
                                        <button
                                            key={c.Id}
                                            type='button'
                                            onClick={() => onConfirm(c)}
                                            className='p-3 w-full text-left rounded-xl border hover:bg-gray-50 focus:ring-2 focus:ring-blue-500'
                                        >
                                            <div className='flex justify-between items-center'>
                                                <div>
                                                    <div className='font-medium'>{c.FullName ?? c.Name ?? 'Contact'}</div>
                                                    <div className='text-sm text-gray-600'>
                                                        {c.Email} • {c.Account?.Name ?? 'Account'}
                                                    </div>
                                                </div>
                                            </div>
                                        </button>
                                    ))}
                                </div>

                                <div className='flex gap-2 justify-end mt-6'>
                                    <button
                                        type='button'
                                        onClick={onCancel}
                                        className='px-4 py-2 rounded-lg border hover:bg-gray-50'
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}
